import { css } from "@emotion/react";

export const variablesCss = css`
  :root {
    --min-height-content-layout: 500px;
    --error-color: #ff4d4f;
  }
`;
